// jscs:disable requireCamelCaseOrUpperCaseIdentifiers
// jshint camelcase:false
import $ from 'jquery';
import _ from 'underscore';
import mediator from '../../js/mediator';
import * as config from '../../js/config';
import * as utilities from '../../js/utilities';

// This is a base class and should only ever be extended to set API end point.
export default class RichRelevancePlacement {
  constructor(el, options = {}) {
    this.el = el;
    this.$el = $(el);
    this.placementName = this.$el.data('placement-name');
    this.initializeOptions(options);

    if (!_.isUndefined(window.RR) && !_.isUndefined(window.RR.data) && !_.isUndefined(window.RR.data.JSON) && !_.isUndefined(window.RR.data.JSON.placements)) {
      this.onPlacementsReceived(window.RR.data.JSON.placements);
    } else {
      // This will be triggered by RR.jsonCallback in the actual page
      mediator.on(config.events.richRelevance.placementsReceived, this.onPlacementsReceived, this);
    }
  }

  initializeOptions(options) {
    this.endPointUrl = options.endPointUrl;
  }

  onPlacementsReceived(placements) {
    if (!placements || !placements.length) {
      return;
    }

    let placement = _.find(placements, (p) => (p.placement_name === this.placementName));

    if (placement) {
      mediator.off(config.events.richRelevance.placementsReceived, this.onPlacementsReceived, this);
      this.requestPlacementHTML(placement);
    }
  }

  getAjaxParams(placement) {
    // Include all of the data attributes
    var data = _.extend({ recommendationJson: JSON.stringify(placement) }, this.el.dataset);

    return utilities.addCustIpToDataObject(data);
  }

  requestPlacementHTML(placement) {
    let promise = $.ajax(this.endPointUrl, {
      dataType: 'html',
      method: 'post',
      data: this.getAjaxParams(placement),
      handleErrorLocally: true //stop global error in errorHandler
    });

    promise.done(_.bind(this.onHTMLReceived, this));
  }

  onHTMLReceived(html) {
    if (!this.isValidHTML(html)) {
      return;
    }

    this.$el.html(html);
    this.$el.addClass(config.classes.isActive);
    this.$el.find('.InformationTile-link, .ProductPricing-buyingOption').click(_.bind(this.onBuyingOptionClick, this));

    mediator.trigger(config.events.ui.ajaxContentLoaded, this.$el);
  }

  onBuyingOptionClick(e) {
    if (!e.currentTarget.dataset.rrclickurl) {
      return;
    }
    e.preventDefault();
    var clickUrl = e.currentTarget.dataset.rrclickurl;
    var promise = $.ajax({
      type: 'GET',
      url: clickUrl,
      handleErrorLocally: true
    });
    promise.always(function() {
      window.location.href = e.currentTarget.href;
    })
  }

  isValidHTML(html) {
    if (typeof html !== 'string') {
      return false;
    }
    return (html.indexOf('<title>') === -1) && html.length;
  }
}



// WEBPACK FOOTER //
// ./assets/components/RichRelevance/RichRelevance-Placement.js